import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { FindAllMarcaProductoSelectAction } from "../../actions/marcaActions/FindAllSelectMarcaProductoAction";

export function useMarcaProductoSelect() {
  
  const query = useQuery({
    queryKey: ["MarcaProductosList"],
    queryFn: () => FindAllMarcaProductoSelectAction(),
    staleTime: 60 * 1000,
  });

  const MarcasProductos = computed(() => query.data.value?.data?.data || []);

  return {
    ...query,
    MarcasProductos,
  };
}
